import styles from './style.module.css';
import { Button } from '../Button';
import { Markup } from 'interweave';
import { useEffect, useRef, useState } from 'react';

interface ITextReveal {
  title?: string | undefined;
  subtitle?: string;
  content: string;
  conversionFieldName?: string;
  dataSheet?: string;
}

export function TextReveal({
  title,
  subtitle,
  content,
  conversionFieldName,
  dataSheet,
}: ITextReveal) {
  const [showMoreView, setShowMoreview] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>();
  const [heightContentTextElement, setHeightContentTextElement] =
    useState<number>();
  const contentTextElement = useRef<HTMLDivElement>(null);
  const [contentData, setContentData] = useState<string>('');

  useEffect(() => {
    setContentData(content);
  }, []);

  useEffect(() => {
    if (contentData && contentData.length >= 300) {
      setShowMoreview(true);
    } else {
      setShowMoreview(false);
    }
    if (contentTextElement.current) {
      setHeightContentTextElement(contentTextElement.current.clientHeight);
    }
  }, [contentData, contentTextElement, heightContentTextElement]);

  function handleView() {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className="text-wrapper mt-3">
        <div className="d-flex justify-content-between">
          <h1 className={`mb-4 ${styles.title}`}>{title}</h1>
          {dataSheet && (
            <a rel="noopener noreferrer" target="_blank" href={dataSheet}>
              <div className="d-flex justify-content-center align-items-center">
                <span className="material-icons-outlined">file_download</span>
                <span className="text-center">
                  {conversionFieldName
                    ? `Baixar ${conversionFieldName}`
                    : 'Baixar ficha técnica'}
                </span>
              </div>
            </a>
          )}
        </div>
        {subtitle && (
          <>
            <h2 className={styles.subtitle}>{subtitle}</h2>
            <hr />
          </>
        )}
        <div
          className={`mb-3 ${styles.contentText} ${
            showMoreView && !isOpen ? styles.close : styles.open
          }`}
          style={{ height: isOpen ? heightContentTextElement : '' }}
        >
          <div ref={contentTextElement}>
            <Markup content={content} />
          </div>
        </div>
      </div>

      {showMoreView && (
        <div className="mb-3">
          <Button
            onClick={handleView}
            text={`Ver ${!isOpen ? 'mais' : 'menos'}`}
            color="flat"
            icon="add"
          />
        </div>
      )}
    </>
  );
}
